export type Clause = string;

type Operand = string | number | boolean | null;

function quote(v: string): string {
  return `'${v.replace(/'/g, "''")}'`;
}

function operand(v: Operand): string {
  if (v === null) return "null";
  if (typeof v === "string") return quote(v);
  return String(v);
}

function compare(op: string) {
  return (col: string, v: Operand): Clause => `${col} ${op} ${operand(v)}`;
}

function fn(name: string) {
  return (col: string, v: string): Clause => `${name}(${col},${quote(v)})`;
}

function join(op: "and" | "or", clauses: Array<Clause | undefined | null>): Clause {
  const parts = clauses.filter((c): c is Clause => !!c && c.length > 0);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0];
  const joined = parts.join(` ${op} `);
  return op === "or" ? `(${joined})` : joined;
}

export const odata = {
  quote,
  eq: compare("eq"),
  ne: compare("ne"),
  gt: compare("gt"),
  ge: compare("ge"),
  lt: compare("lt"),
  le: compare("le"),
  contains: fn("contains"),
  startswith: fn("startswith"),
  endswith: fn("endswith"),
  /** Raw operand for unquoted values (datetimes, expressions). */
  raw: (col: string, op: string, v: string): Clause => `${col} ${op} ${v}`,
  and: (...clauses: Array<Clause | undefined | null>): Clause => join("and", clauses),
  or: (...clauses: Array<Clause | undefined | null>): Clause => join("or", clauses),
};
